module.exports = __webpack_public_path__ + "img/thumb-si-les-os-s-animent.3d5d146e.jpg";